import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../utils/constants/api";
import { ApiResponse } from "../../../types/APIResponse";
import { LanguageConfigurationData } from "./languageConfigurationSlice";
import { apiEndpoints } from "../../../utils/constants/apiEndpoints";

export const fetchLanguageConfiguration = createAsyncThunk(
  "languageConfiguration/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const response: ApiResponse<LanguageConfigurationData> = await api.get(apiEndpoints.languageConfig.getAll);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch language configuration");
    }
  }
);

export const updateLanguageConfiguration = createAsyncThunk(
  "languageConfiguration/update",
  async (configData: LanguageConfigurationData, { rejectWithValue }) => {
    try {
      const response: ApiResponse<LanguageConfigurationData> = await api.post(apiEndpoints.languageConfig.update, {
        data: configData,
      });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || "Failed to update language configuration");
    }
  }
);
